import { gql } from '@apollo/client';
import { MeetingPlaceLinkToAnyPageFragment } from './meetingPlaceLinkToAnyPage';
// import { SvgFragment } from './svg';

export const EntryFragment = gql`
  ${MeetingPlaceLinkToAnyPageFragment}
  fragment Entry on Entry {
    __typename
    ... on _Node {
      ... on MeetingPlacePageEditorial {
        slug
      }
      ... on MeetingPlacePageEditorialFullWidth {
        slug
      }
      ... on MeetingPlacePageSearchResults {
        slug
      }
      ... on MeetingPlacePageFindUs {
        slug
      }
      ... on MeetingPlacePageLegalDocument {
        slug
      }
      ... on MeetingPlacePageEvent {
        slug
      }
      ... on MeetingPlacePageTenantList {
        slug
      }
      ... on MeetingPlacePageOccasions {
        slug
      }
      ... on MeetingPlacePageEventList {
        slug
      }
      ... on MeetingPlacePageTenantEntertainmentList {
        slug
      }
      ... on MeetingPlacePageTenantFoodbeverageList {
        slug
      }
      ... on MeetingPlacePageTenantShopList {
        slug
      }
      ... on MeetingPlacePageNewsItem {
        slug
      }
      ... on MeetingPlacePageOffer {
        slug
      }
      ... on MeetingPlacePageService {
        slug
      }
      ... on MeetingPlacePageTenantEntertainment {
        slug
      }
      ... on MeetingPlacePageTenantFoodBeverage {
        slug
      }
      ... on MeetingPlacePageTenantShop {
        slug
      }
      ... on BlockLink {
        sys {
          id
          locale
        }
        linkText
        externalLink
        openInNewWindow
        internalLink {
          ...MeetingPlaceLinkToAnyPage
        }
        mediaField {
          jsonBynderAsset
          altText
        }
      }
    }
  }
`;

